import styled from '@emotion/styled';
import { Breakpoints, Colors, Input } from 'goalsetter-webapp-components';
import { Image } from '@mantine/core';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 64px;
  width: 864px;
  margin-bottom: 70px;
  @media (max-width: ${Breakpoints.sm_portal}px) {
    width: 95%;
    padding-top: 16px;
    padding-bottom: 42px;
  }
`;

export const StyledImage = styled(Image)`
  padding-top: 24px;
  & .mantine-Image-image {
    border-radius: 12px;
  }
`;

export const StyledInput = styled(Input)`
  padding-top: 16px;
  padding-bottom: 24px;
  input::placeholder {
    color: ${Colors.MEDIUM_EMPHASIS};
  }
  & .mantine-TextInput-error {
    color: ${Colors.RED} !important;
  }
`;

export const StyledZipCodeInput = styled(Input)`
  width: 100%;
  input::placeholder {
    color: ${Colors.MEDIUM_EMPHASIS};
  }
  & .mantine-TextInput-error {
    color: ${Colors.RED} !important;
  }
`;

export const titleStyle = (isMobile?: boolean) => ({
  paddingTop: isMobile ? '32px' : '40px',
  paddingBottom: '40px',
});

export const mainCardsWrapperStyle = { gap: '16px', width: '100%' };

export const leftCardStyle = (isMobile?: boolean) => ({
  width: !isMobile ? '65%' : '100%',
  order: isMobile ? 2 : 1,
});

export const rightCardStyle = (isMobile?: boolean) => ({
  width: !isMobile ? '35%' : '100%',
  height: 'fit-content',
  order: isMobile ? 1 : 2,
});

export const rowPaddingTop = { paddingTop: '16px' };
export const textStyle = { fontWeight: 400 };
export const goalCardRegisteredTrademarkStyle = { fontSize: '12px' };
export const continueButtonStyle = { margin: '24px 0' };
export const termsStyle = (isMobile?: boolean) => ({
  color: isMobile ? Colors.WHITE : Colors.MEDIUM_EMPHASIS,
  width: '100%',
  fontFamily: 'Avenir',
  fontSize: '16px',
  fontStyle: 'normal',
  fontWeight: 500,
  lineHeight: '24px',
});

export const termsLinkStyle = {
  color: Colors.BLUE_LIGHT,
  fontFamily: 'Avenir',
  fontSize: '16px',
  fontStyle: 'normal',
  fontWeight: 900,
  lineHeight: '24px',
  textDecorationLine: 'underline',
};

export const flexContainerStyle = { paddingTop: '24px' };
export const serviceFeeflexContainerStyle = {
  padding: '8px 0',
  borderBottom: `1px solid ${Colors.GRAY_DARK}`,
};

export const fullWidth = { width: '100%' };
